const defaultSettings = require('@/settings.js');
export default function authHeader() {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.accessToken) {
        return {
            Authorization: 'Bearer ' + user.accessToken,
            // 'Access-Control-Allow-Origin': 'http://localhost:8080'
            'Access-Control-Allow-Origin': defaultSettings.apiUrl
        };
    }
    return {};
}
